import { render, staticRenderFns } from "./RevenueDynamics.vue?vue&type=template&id=33546f62&scoped=true&"
import script from "./RevenueDynamics.vue?vue&type=script&lang=js&"
export * from "./RevenueDynamics.vue?vue&type=script&lang=js&"
import style0 from "./RevenueDynamics.vue?vue&type=style&index=0&id=33546f62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33546f62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VContainer,VRow})
